const HLS_RE = /\.m3u8($|\?)/i;
export const QUALITY_OPTIONS = ["Auto", "1080p", "720p", "480p"];
const H264 = 'video/mp4; codecs="avc1.42E01E"';

function canPlay(url) {
  const probe = document.createElement("video");
  if (HLS_RE.test(url)) return !!probe.canPlayType("application/vnd.apple.mpegurl") || !!window.MediaSource?.isTypeSupported?.(H264);
  if (/\.webm($|\?)/i.test(url)) return !!probe.canPlayType('video/webm; codecs="vp9"');
  if (/\.(mp4|m4v|mov)($|\?)/i.test(url)) return !!probe.canPlayType(H264);
  return true;
}

// Picks the first source the current browser can decode (primary first, then fallbacks).
export function pickSource(primary, alternates = []) {
  const all = [primary, ...(alternates || [])].filter(Boolean);
  return all.find(canPlay) || all[0];
}

// Attaches a media source to a <video>; returns a controller exposing quality selection.
export async function attachSource(video, url) {
  const isHls = HLS_RE.test(url);
  if (isHls && !video.canPlayType("application/vnd.apple.mpegurl")) {
    const { default: Hls } = await import("hls.js");
    if (Hls.isSupported()) {
      video.dataset.sourceToken = "hls";
      const hls = new Hls({ enableWorker: true });
      hls.loadSource(url);
      hls.attachMedia(video);
      return {
        type: "hls",
        setQuality: (label) => {
          if (label === "Auto") return (hls.currentLevel = -1);
          const target = parseInt(label, 10);
          const idx = hls.levels.reduce((best, l, i) => (Math.abs(l.height - target) < Math.abs((hls.levels[best]?.height || 0) - target) ? i : best), 0);
          hls.currentLevel = idx;
        },
        destroy: () => hls.destroy(),
      };
    }
  }
  video.src = url;
  const token = String(Math.random());
  video.dataset.sourceToken = token;
  return {
    type: isHls ? "native-hls" : "progressive",
    setQuality: () => {},
    destroy: () => {
      if (video.dataset.sourceToken !== token) return;
      video.removeAttribute("src");
      video.load();
    },
  };
}
